import { http } from '../../core/services/http';
import { FleetRouteInstance } from '../interfaces/FleetRouteInstance';

export const loadFleetRouteInstances = () =>
  http.get<FleetRouteInstance[]>(`common/fleetRouteInstances`).then(response => response.data);
